const team = [
  {
    id: 'kousik',
    img: 'https://static.readdy.ai/image/d80b109f077bb32eaa0599f7baacf71d/e3ab00be16a4cd75c3aa821bf93b2f29.jpeg',
    imgAlt: 'Kousik Paitandi - Founder & CEO',
    name: 'Kousik Paitandi, MBA, MS',
    role: 'Founder & CEO',
    badge: 'ri-star-fill',
    bio: 'Visionary leader with extensive experience in AI-driven digital transformation and strategic business development. Holds an MBA and an MS in Computational Biology. Specializes in cross-industry AI implementation, pharmaceutical technology consulting, and building scalable intelligent systems that bridge cutting-edge research and practical business applications.',
  },
  {
    id: 'rajendra',
    img: 'https://public.readdy.ai/ai/img_res/fd38ec3bf2bf167ec44e8b9b65cdea6e.jpg',
    imgAlt: 'Rajendra Prasad, PhD - Chief Scientific Advisor',
    name: 'Rajendra Prasad, PhD',
    role: 'Chief Scientific Advisor',
    badge: 'ri-flask-line',
    bio: 'An accomplished deep-tech researcher with 13+ years of experience, including elite fellowships at Kyoto University (JSPS) and Peking University. With 33 high-impact publications (h-index 17), he is a global expert in semiconducting COFs/MOFs and organometallic therapeutics. His breakthrough research forms the technical bedrock of Éclat-Gen\'s "Lab-in-a-Loop" platform.',
  },
];

export default function TeamSection() {
  return (
    <section id="team" className="py-24" style={{ background: 'linear-gradient(180deg, #0d0d1a 0%, #09090f 100%)' }}>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <span className="inline-block text-xs font-semibold tracking-[0.25em] uppercase mb-4" style={{ color: '#c9a84c' }}>
            Leadership
          </span>
          <h2 className="text-4xl font-light text-white mb-6 tracking-tight">
            Meet the{' '}
            <span style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', WebkitBackgroundClip: 'text', WebkitTextFillColor: 'transparent', fontWeight: 700 }}>
              Architects
            </span>
          </h2>
          <p className="text-lg text-white/45 max-w-2xl mx-auto font-light">
            Our leadership team combines decades of cross-industry expertise with cutting-edge AI innovation to guide organizations through transformative digital evolution
          </p>
        </div>

        <div className="grid md:grid-cols-2 gap-8 max-w-4xl mx-auto mb-16">
          {team.map((member) => (
            <div
              key={member.id}
              className="p-8 transition-all duration-300 group"
              style={{ background: 'rgba(255,255,255,0.02)', border: '1px solid rgba(201,168,76,0.15)', borderRadius: '12px' }}
              onMouseEnter={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.35)';
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(201,168,76,0.04)';
              }}
              onMouseLeave={(e) => {
                (e.currentTarget as HTMLDivElement).style.borderColor = 'rgba(201,168,76,0.15)';
                (e.currentTarget as HTMLDivElement).style.background = 'rgba(255,255,255,0.02)';
              }}
            >
              <div className="text-center mb-6">
                <div className="relative inline-block mb-4">
                  <div className="absolute inset-0 rounded-full opacity-30 blur-md" style={{ background: 'radial-gradient(circle, #c9a84c, transparent)' }} />
                  <img
                    alt={member.imgAlt}
                    className="w-28 h-28 rounded-full object-cover object-top relative z-10"
                    style={{ border: '2px solid rgba(201,168,76,0.4)' }}
                    src={member.img}
                  />
                  <div
                    className="absolute -bottom-1 -right-1 w-8 h-8 flex items-center justify-center z-20"
                    style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', borderRadius: '50%' }}
                  >
                    <i className={`${member.badge} text-[#09090f] text-sm`} />
                  </div>
                </div>
                <h3 className="text-xl font-semibold text-white/90 mb-1 tracking-wide">{member.name}</h3>
                <p className="text-sm font-medium tracking-[0.1em] uppercase" style={{ color: '#c9a84c' }}>{member.role}</p>
              </div>
              <p className="text-sm text-white/45 font-light leading-relaxed text-center mb-5">{member.bio}</p>
              <div className="flex justify-center gap-3">
                {['ri-linkedin-fill', 'ri-twitter-fill'].map((icon) => (
                  <div
                    key={icon}
                    className="w-8 h-8 flex items-center justify-center cursor-pointer transition-all duration-300 hover:scale-110"
                    style={{ background: 'rgba(201,168,76,0.1)', borderRadius: '6px', border: '1px solid rgba(201,168,76,0.2)' }}
                  >
                    <i className={`${icon} text-sm`} style={{ color: '#c9a84c' }} />
                  </div>
                ))}
              </div>
            </div>
          ))}
        </div>

        {/* Advisory Network */}
        <div
          className="max-w-4xl mx-auto p-10 text-center"
          style={{ background: 'rgba(201,168,76,0.04)', border: '1px solid rgba(201,168,76,0.2)', borderRadius: '12px' }}
        >
          <div className="w-12 h-12 flex items-center justify-center mx-auto mb-5" style={{ background: 'rgba(201,168,76,0.1)', border: '1px solid rgba(201,168,76,0.25)', borderRadius: '10px' }}>
            <i className="ri-group-line text-xl" style={{ color: '#c9a84c' }} />
          </div>
          <h3 className="text-2xl font-semibold text-white/90 mb-3 tracking-wide">Join Our Advisory Network</h3>
          <p className="text-sm text-white/45 mb-6 font-light leading-relaxed max-w-xl mx-auto">
            We&apos;re always looking for exceptional leaders and industry experts passionate about AI-driven transformation. If you have deep expertise in your field, we&apos;d love to connect.
          </p>
          <a
            href="#contact"
            className="inline-flex items-center gap-2 px-7 py-3 text-sm font-semibold whitespace-nowrap cursor-pointer tracking-wide transition-all duration-300 hover:opacity-90"
            style={{ background: 'linear-gradient(135deg, #c9a84c, #e8c87a)', color: '#09090f', borderRadius: '4px' }}
          >
            Explore Advisory Opportunities <i className="ri-arrow-right-line" />
          </a>
        </div>
      </div>
    </section>
  );
}
